import { render, staticRenderFns } from "./Administration_RecipesCoating.vue?vue&type=template&id=5dccdbd3"
import script from "./Administration_RecipesCoating.vue?vue&type=script&lang=js"
export * from "./Administration_RecipesCoating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports